import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=cd3badd8&scoped=true&"
import script from "./Purchases.vue?vue&type=script&lang=ts&"
export * from "./Purchases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3badd8",
  null
  
)

export default component.exports